<template>
  <t-card v-loading="showFlag">
    <t-form
      ref="supplierInfoFormData"
      :model="supplierInfoFormData"
      domain="supplierInfoFormData"
      label-position="right"
      label-width="110px"
      class="supplierInfoForm"
    >
      <t-row>
        <t-col :span="12">
          <!-- 仕入先コード -->
          <t-form-item
            :label="$t('resource.supplierInfo.supplierCode')"
            prop="supCode"
          >
            <t-input
              v-model="supplierInfoFormData.supCode"
              :disabled="disabled"
              clearable
              maxLength="3"
              style="width: 97%"
            ></t-input> </t-form-item
        ></t-col>
        <t-col :span="12">
          <!-- 省略字 -->
          <t-form-item
            :label="$t('resource.supplierInfo.supplierAbb')"
            prop="supAbb"
          >
            <t-input
              v-model="supplierInfoFormData.supAbb"
              maxLength="3"
              clearable
              style="width: 97%"
            ></t-input> </t-form-item
        ></t-col>
      </t-row>

      <t-row>
        <t-col :span="12">
          <!-- 仕入先名 -->
          <t-form-item
            :label="$t('resource.supplierInfo.supplierName')"
            prop="supName"
          >
            <t-input
              v-model="supplierInfoFormData.supName"
              maxLength="40"
              clearable
              style="width: 97%"
            ></t-input> </t-form-item
        ></t-col>
        <t-col :span="12">
          <!-- 仕入先略称 -->
          <t-form-item
            :label="$t('resource.supplierInfo.supplierAbbreviation')"
            prop="supAbbreviation"
          >
            <t-input
              v-model="supplierInfoFormData.supAbbreviation"
              maxLength="15"
              clearable
              style="width: 97%"
            ></t-input> </t-form-item
        ></t-col>
      </t-row>

      <t-row>
        <t-col :span="12">
          <!-- アドレス -->
          <t-form-item
            :label="$t('resource.supplierInfo.supplierAddress')"
            prop="supAdd"
          >
            <t-input
              v-model="supplierInfoFormData.supAdd"
              maxLength="100"
              clearable
              style="width: 97%"
            ></t-input> </t-form-item
        ></t-col>

        <t-col :span="12">
          <!-- TEL -->
          <t-form-item
            :label="$t('resource.supplierInfo.supplierTel')"
            prop="supTel"
          >
            <t-input
              v-model="supplierInfoFormData.supTel"
              maxLength="15"
              clearable
              style="width: 97%"
            ></t-input></t-form-item
        ></t-col>
      </t-row>
      <t-row>
        <t-col :span="12">
          <!-- FAX -->
          <t-form-item
            :label="$t('resource.supplierInfo.supplierFAX')"
            prop="supFax"
          >
            <t-input
              v-model="supplierInfoFormData.supFax"
              maxLength="20"
              clearable
              style="width: 97%"
            ></t-input></t-form-item
        ></t-col>

        <t-col :span="12">
          <!-- 郵便番号 -->
          <t-form-item
            :label="$t('resource.supplierInfo.supplierZipCode')"
            prop="supZipcode"
          >
            <t-input
              v-model="supplierInfoFormData.supZipcode"
              maxLength="15"
              clearable
              style="width: 97%"
            ></t-input> </t-form-item
        ></t-col>
      </t-row>
      <t-row>
        <t-col :span="12">
          <!-- 貨幣 -->
          <t-form-item
            :label="$t('resource.supplierInfo.currency')"
            prop="supCurrency"
          >
            <t-select
              v-model="supplierInfoFormData.supCurrency"
              placeholder=""
              clearable
              class="commonDialog"
              style="width: 97%"
            >
              <t-option
                v-for="item in supCurrencyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </t-option>
            </t-select> </t-form-item
        ></t-col>

        <t-col :span="12">
          <!-- 工場 -->
          <t-form-item
            :label="$t('resource.supplierInfo.supFactoryKbn')"
            prop="supFactoryKbn"
          >
            <!-- UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓ -->
            <!-- <t-select
              v-model="supplierInfoFormData.supFactoryKbn"
              placeholder=""
              clearable
              class="commonDialog"
              style="width: 97%"
            > -->
            <t-select
              v-model="supplierInfoFormData.supFactoryKbn"
              placeholder=""
              clearable
              class="commonDialog"
              style="width: 97%"
              @change="factoryKbnChange"
            >
              <!-- UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑ -->
              <t-option
                v-for="item in supFactoryKbnList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </t-option>
            </t-select> </t-form-item
        ></t-col>
      </t-row>
      <t-row>
        <t-col :span="12">
          <!-- 連絡先 -->
          <t-form-item
            :label="$t('resource.supplierInfo.supplierContacts')"
            prop="supContacts"
          >
            <t-input
              v-model="supplierInfoFormData.supContacts"
              maxLength="20"
              clearable
              style="width: 97%"
            ></t-input> </t-form-item
        ></t-col>

        <!-- ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
        <!-- 関連仕入先区分の追加 -->
        <t-col :span="12">
          <!-- 関連仕入先 -->
          <t-form-item
            v-if="supplierInfoFormData.supFactoryKbn !== '1'"
            :label="$t('resource.supplierInfo.SUP_RELATE_FLAG')"
          >
            <t-switch
              v-model="supplierInfoFormData.supRelateBool"
            ></t-switch> </t-form-item
        ></t-col>
        <!-- ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
      </t-row>

      <t-row>
        <t-col :span="12">
          <!-- 連絡先TEL -->
          <t-form-item
            :label="$t('resource.supplierInfo.supplierContactTel')"
            prop="supContactsTel"
          >
            <t-input
              v-model="supplierInfoFormData.supContactsTel"
              maxLength="15"
              clearable
              style="width: 97%"
            ></t-input> </t-form-item
        ></t-col>
        <t-col :span="12">
          <!-- 連絡先Mail -->
          <t-form-item
            :label="$t('resource.supplierInfo.supplierContactMail')"
            prop="supContactsMail"
          >
            <t-input
              v-model="supplierInfoFormData.supContactsMail"
              maxLength="50"
              clearable
              style="width: 97%"
            ></t-input> </t-form-item
        ></t-col>
      </t-row>

      <t-row>
        <t-col :span="12">
          <!-- 終了日 -->
          <t-form-item
            :label="$t('resource.supplierInfo.endDate')"
            prop="supEndDate"
          >
            <t-date-picker
              v-model="supplierInfoFormData.supEndDate"
              type="date"
              :placeholder="$t('resource.sys.hidden')"
              value-format="yyyy/MM/dd"
              format="yyyy/MM/dd"
              :editable="false"
              :clearable="false"
              style="width: 97%"
            ></t-date-picker>
          </t-form-item>
        </t-col>
      </t-row>

      <t-row type="flex" justify="end">
        <div>
          <t-col :span="24">
            <!-- 確定  -->

            <t-button
              v-if="isAddFlg"
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              @click="Confirm"
            >
              <i class="el-icon-check"></i>
              {{ $t("resource.sys.sure") }}</t-button
            >

            <!-- 变更 -->

            <t-button
              v-else
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              @click="Confirm"
            >
              <i class="el-icon-check"></i>
              {{ $t("resource.sys.sure") }}</t-button
            >
          </t-col>
        </div>
      </t-row>
    </t-form>
  </t-card>
</template>
<script>
import { t } from "@/locales";
import {
  AddSupInfo,
  ChangeSupInfo,
  GetSelectList,
  GetSupMstInfoByCode,
} from "@/services/supplierInfo";
import { cmpBasicData } from "@/utils/comFunction";
import { contractionList, NUM_ONE, STR_ONE, STR_ZERO } from "@/utils/const";
// import { DateFormat } from "@/utils/filter";
import { Message as MessageA, Modal } from "@tellus/component";
import { Message } from "@tellus/ui";
export default {
  data() {
    return {
      inputWidth: "55%",
      // :style="{ width: inputWidth }"
      supplierInfoForm: {},

      supplierInfoFormData: {
        supCode: "",
        supAbb: "",
        supName: "",
        supAbbreviation: "",
        supAdd: "",
        supTel: "",
        supFax: "",
        supZipcode: "",
        supCurrency: "",
        supFactoryKbn: "",
        supContacts: "",
        supContactsTel: "",
        supContactsMail: "",
        supEndDate: "",
        // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓
        supRelateBool: false,
        // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑
      },
      supCurrencyList: [],
      supFactoryKbnList: [],
      disabled: false,
      showFlag: false,
      isAddFlg: false,

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},

      // 比較用明細情報
      cmpDetailResult: {},
    };
  },
  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    rowData: {
      Type: Object,
    },
  },

  mounted() {
    this.isAddFlg = this.isAdd;
    this.showFlag = true;
    // select情報の取得
    this.GetSelectList();
  },
  methods: {
    // 初期化
    Init(supCode) {
      this.showFlag = true;
      this.disabled = true;
      this.SearchClick(supCode);
    },
    // 編集
    Confirm() {
      this.$refs.supplierInfoFormData.validate((valid) => {
        if (valid) {
          this.supplierInfoFormData.updateUser = localStorage.getItem("userId");
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // 関連仕入先区分の追加
          this.supplierInfoFormData.supRelateFlag =
            this.supplierInfoFormData.supFactoryKbn !== STR_ONE
              ? this.supplierInfoFormData.supRelateBool
                ? STR_ONE
                : STR_ZERO
              : STR_ZERO;
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

          if (this.isAddFlg) {
            AddSupInfo(this.supplierInfoFormData, () => {
              this.isAddFlg = false;
              this.numLoads = 1;
              this.Init(this.supplierInfoFormData.supCode);
              MessageA.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
            }).catch((err) => {
              if (err.data != null) {
                contractionList.key = err.data.Data;
                if (err.data.Messages[0].Id === "supErr") {
                  Modal.showWarning(
                    "",
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message),
                    {
                      confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
                    }
                  );
                } else {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                }
              } else {
                Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
              }
            });
          } else {
            ChangeSupInfo(this.supplierInfoFormData, () => {
              this.numLoads = 1;

              this.Init(this.supplierInfoFormData.supCode);

              MessageA.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
            }).catch((err) => {
              if (err.data != null) {
                contractionList.key = err.data.Data;
                if (err.data.Messages[0].Id === "supErr") {
                  Modal.showWarning(
                    "",
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message),
                    {
                      confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
                    }
                  );
                } else {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                }
              } else {
                Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
              }
            });
          }
        }
      });
    },

    // select情報の取得
    GetSelectList() {
      GetSelectList()
        .then((res) => {
          this.supCurrencyList = res.CuryTypeList;
          this.supFactoryKbnList = res.FactoryList;
          contractionList.key = res.ContractionList;

          if (!this.isAddFlg) {
            this.Init(this.rowData.supCode);
          } else {
            this.supplierInfoFormData.supEndDate = "2099/12/31";
            this.showFlag = false;

            // 比較用基本情報の初期化
            this.initComparisonInfo();
          }
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }

          this.showFlag = false;
        });
    },

    SearchClick(cusCode) {
      GetSupMstInfoByCode(cusCode)
        .then((res) => {
          this.supplierInfoFormData = res.Result;
          contractionList.key = res.ContractionList;

          // 比較用基本情報の初期化
          this.initComparisonInfo();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // 比較用基本情報の初期化
    initComparisonInfo() {
      if (this.numLoads == 1) {
        // 比較用基本情報
        this.cmpBasicResult = JSON.parse(
          JSON.stringify(this.supplierInfoFormData)
        );

        // 読み込み回数 + 1
        this.numLoads = this.numLoads + 1;
      }
    },

    // ダイアログを閉じる
    onCancel() {
      if (!cmpBasicData(this.cmpBasicResult, this.supplierInfoFormData)) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
    // 工場が「大連→日本→大連」の変更後、関連区分がオンの場合、関連区分をオフに設定
    factoryKbnChange(value) {
      // 大連工場の場合、関連区分をオフに設定
      if (value === STR_ONE && this.supplierInfoFormData.supRelateBool) {
        this.supplierInfoFormData.supRelateBool = false;
      }
    },
    // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
